import React, { useEffect, useState } from 'react';
import Icon from '@fandom-frontend/react-common/dist/components/Icon';
import useTrackImpression from 'fandom-frontend-ready/tracking/useTrackImpression';
import { getCurrentPage } from 'pathfinder/modules/RegistrationButton/utils/getCurrentPage';
import { CurrentPageType } from 'pathfinder/modules/RegistrationButton/types';
import { StyledButton, Wrapper } from './styled';
export const RegistrationButtonWrapper = ({ track, registerUrl, signInUrl, registerButtonText, signInButtonText, }) => {
    const { ref, onScreen } = useTrackImpression();
    const [impressionTracked, setImpressionTracked] = useState(false);
    const currentPageType = getCurrentPage();
    const onRegisterClick = () => {
        track.click({
            label: 'account.register',
        });
    };
    const onSignInClick = () => {
        track.click({
            label: 'account.sign-in',
        });
    };
    useEffect(() => {
        if (onScreen && !impressionTracked) {
            track.impression({});
            setImpressionTracked(true);
        }
    }, [onScreen]);
    return (React.createElement(Wrapper, { ref: ref, "$currentPageType": currentPageType },
        React.createElement(StyledButton, { href: signInUrl, rel: "nofollow", onClick: onSignInClick, secondary: true, "$hasButtonCommonColors": currentPageType === CurrentPageType.F2_TOPIC_PAGE, "$hasGlobalNavColors": currentPageType === CurrentPageType.FAN_CENTRAL || currentPageType === CurrentPageType.F2_HOMEPAGE, "$isEqualSize": currentPageType === CurrentPageType.F2_TOPIC_PAGE }, signInButtonText),
        React.createElement(StyledButton, { href: registerUrl, rel: "nofollow", onClick: onRegisterClick, "$hasButtonCommonColors": currentPageType === CurrentPageType.F2_TOPIC_PAGE, "$hasGlobalNavColors": currentPageType === CurrentPageType.FAN_CENTRAL || currentPageType === CurrentPageType.F2_HOMEPAGE, "$isEqualSize": currentPageType === CurrentPageType.F2_TOPIC_PAGE },
            React.createElement(Icon, { name: "avatar", small: true }),
            React.createElement("span", null, registerButtonText))));
};
